import styled from "styled-components";
import Select from "react-select";
import { fontDisplay, fontUi } from "../../theme/typography";
import { selectMenuCss } from "../../theme/selectStyles";
export const Landing = styled.div`
  ${fontUi};
  --landing-bg: #03180f;
  --landing-card: #10251b;
  --landing-inset: #1c3227;
  --landing-line: #293e33;
  --landing-accent: #24f59a;
  --landing-muted: #b3c0b9;
  background: var(--landing-bg);
  color: #f8fcfa;
  height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scroll-padding-top: 100px;
  * {
    box-sizing: border-box;
  }
  button,
  input,
  a {
    -webkit-tap-highlight-color: transparent;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  button {
    font: inherit;
    cursor: pointer;
  }
  img {
    max-width: 100%;
  }
  svg {
    flex-shrink: 0;
  }
  a:focus-visible,
  button:focus-visible,
  summary:focus-visible {
    outline: 2px solid var(--landing-accent);
    outline-offset: 5px;
  }
  h1,
  h2,
  h3 {
    ${fontDisplay};
    margin: 0;
  }
  p {
    margin: 0;
    line-height: 1.75;
  }
  .wrap {
    width: min(1120px, calc(100% - 48px));
    margin: auto;
  }
  .topbar {
    height: 72px;
    position: sticky;
    top: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 0 32px;
    border-bottom: 1px solid var(--landing-line);
    background: rgba(13, 34, 23, 0.91);
    backdrop-filter: blur(18px);
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
    font-size: 15px;
    font-weight: 700;
    font-style: italic;
    color: var(--landing-accent);
  }
  .brand svg {
    width: 30px;
    height: 30px;
  }
  .brand svg rect {
    display: none;
  }
  .brand svg path {
    fill: currentColor;
  }
  .account .button svg path {
    fill: currentColor;
  }
  .nav {
    display: flex;
    gap: 32px;
    font-size: 14px;
  }
  .nav a:hover {
    color: var(--landing-accent);
  }
  .account {
    display: flex;
    gap: 16px;
    align-items: center;
  }
  .button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    min-height: 42px;
    padding: 10px 18px;
    border: 1px solid transparent;
    border-radius: ${({ theme }) => theme.controlRadius || "8px"};
    background: var(--landing-accent);
    color: #03180f;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.25;
  }
  .button:hover {
    background: #64ffb9;
  }
  .button.outline {
    background: transparent;
    border-color: #d2ddd6;
    color: #fff;
  }
  .button.outline:hover {
    background: var(--landing-inset);
  }
  .button svg {
    width: 16px;
    height: 16px;
  }
  .menu-toggle {
    display: none;
  }
  .hero {
    display: grid;
    grid-template-columns: 1.22fr 1fr;
    align-items: center;
    gap: 58px;
    min-height: 575px;
    padding-top: 48px;
    padding-bottom: 55px;
  }
  h1 {
    font-size: 48px;
    line-height: 1.02;
    letter-spacing: -0.015em;
    max-width: 550px;
  }
  .intro {
    font-size: 14px;
    margin-top: 24px;
    max-width: 555px;
  }
  .numbers {
    display: flex;
    gap: 46px;
    margin: 28px 0 26px;
  }
  .numbers strong {
    ${fontDisplay};
    display: block;
    color: var(--landing-accent);
    font-size: 30px;
    line-height: 1.2;
  }
  .numbers span {
    display: block;
    font-size: 12px;
    color: var(--landing-muted);
    margin-top: 4px;
  }
  .stores {
    display: flex;
    gap: 16px;
    align-items: center;
  }
  .stores img {
    display: block;
    height: 40px;
    width: auto;
  }
  .stores a:hover {
    opacity: 0.85;
  }
  .hero-art {
    position: relative;
    width: 100%;
    max-width: 420px;
    aspect-ratio: 420 / 460;
    justify-self: end;
    isolation: isolate;
  }
  .hero-art::before {
    content: "";
    position: absolute;
    inset: 0 -10%;
    background: radial-gradient(ellipse, #05ca6333, transparent 68%);
    z-index: -1;
  }
  .phone,
  .formation-preview {
    position: absolute;
    overflow: hidden;
    border: 1px solid #528e6d;
    background: #10251b;
    box-shadow: 0 12px 24px #0003;
  }
  .hero-art svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .phone {
    border-radius: 7% / 3.8%;
    aspect-ratio: 207 / 378;
  }
  .phone.pitch {
    width: 47.619%;
    left: 0;
    top: 0;
    z-index: 2;
  }
  .phone.discord {
    width: 42.857%;
    left: 39.286%;
    top: 27.174%;
    z-index: 1;
  }
  .formation-preview {
    width: 41.667%;
    aspect-ratio: 207 / 172;
    left: 58.333%;
    top: 8.696%;
    border-radius: 8px;
    background: white;
    z-index: 3;
  }
  .hero-divider {
    border-top: 1px solid var(--landing-line);
  }
  .crest-strip {
    width: 100%;
    padding: 44px 0 16px;
    overflow: hidden;
  }
  .crest-track {
    display: flex;
    width: max-content;
    animation: clubMarquee 80s linear infinite;
  }
  .crest-set {
    display: flex;
    align-items: center;
    gap: 34px;
    padding-right: 34px;
    flex-shrink: 0;
  }
  .crest-button { display:grid; place-items:center; border:0; background:transparent; padding:0; flex-shrink:0; border-radius:8px; transition:transform 180ms ease,filter 180ms ease; }
  .crest-button:hover,.crest-button:focus-visible { transform:translateY(-3px) scale(1.1); filter:drop-shadow(0 5px 10px #24f59a44); }
  .club-carousel:hover .crest-track,.crest-track[data-paused="true"] { animation-play-state:paused; }
  .club-story { position:fixed; z-index:35; padding:22px; overflow-y:auto; border:1px solid #355541; border-radius:${({theme})=>theme.cardRadius || '14px'}; background:#10251b; box-shadow:0 12px 35px #0006; }
  .club-story-heading { display:flex; gap:14px; align-items:center; margin-bottom:14px; }
  .club-story-heading img { width:42px; height:48px; object-fit:contain; }
  .club-story-heading span { color:var(--landing-accent); font-size:11px; }
  .club-story-heading h3 { font-family:var(--tol-font-ui)!important; font-size:17px; line-height:1.3; margin-top:4px; }
  .club-story p { font-size:13px; color:var(--landing-muted); white-space:pre-line; }
  .crest-set img {
    width: 47px;
    height: 54px;
    object-fit: contain;
    flex-shrink: 0;
  }
  @keyframes clubMarquee {
    to {
      transform: translateX(-50%);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .crest-track {
      animation: none;
    }
    .crest-strip {
      overflow-x: auto;
    }
  }
  .team-name {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .table-crest {
    width: 26px;
    height: 30px;
    object-fit: contain;
    flex-shrink: 0;
  }
  .crest-fallback { display:inline-grid; place-items:center; border-radius:5px; background:#284535; color:var(--landing-muted); font-size:12px; }
  .fixture-team {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .fixture-team + .fixture-team {
    margin-top: 5px;
  }
  .fixture-team .table-crest {
    width: 20px;
    height: 22px;
  }
  .section {
    padding: 48px 0;
    border-bottom: 1px solid var(--landing-line);
    scroll-margin-top: 90px;
  }
  .section-head {
    text-align: center;
    margin-bottom: 48px;
  }
  .section h2 {
    font-size: 30px;
    letter-spacing: -0.01em;
    line-height: 1.2;
  }
  .section-head p {
    font-size: 14px;
    margin-top: 12px;
  }
  .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  .panel {
    background: var(--landing-card);
    border: 1px solid var(--landing-line);
    border-radius: ${({ theme }) => theme.cardRadius || "14px"};
    padding: 28px;
    min-width: 0;
  }
  .panel-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 26px;
  }
  .panel-head h3 {
    ${fontUi};
    font-family: var(--tol-font-ui) !important;
    font-size: 15px;
    font-weight: 600 !important;
  }
  .text-link {
    display: inline-flex;
    gap: 5px;
    align-items: center;
    color: var(--landing-accent);
    font-size: 13px;
    font-weight: 600;
  }
  .text-link svg {
    width: 16px;
    height: 16px;
  }
  .text-link:hover {
    text-decoration: underline;
  }
  .selectors {
    display: flex;
    gap: 20px;
    margin-bottom: 24px;
  }
  .data-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .data-row {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 56px;
    padding: 12px 16px;
    border-radius: ${({ theme }) => theme.controlRadius || "8px"};
    background: var(--landing-inset);
    font-size: 13px;
  }
  .data-row .rank {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: var(--landing-accent);
    color: #052315;
    font-weight: 700;
    flex-shrink: 0;
  }
  .data-row .team-name {
    flex: 1;
    min-width: 0;
  }
  .points,
  .result-score {
    margin-left: auto;
    color: var(--landing-accent);
    white-space: nowrap;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .fixtures .data-row {
    min-height: 74px;
  }
  .fixture-copy {
    min-width: 0;
    flex: 1;
  }
  .fixture-copy > span {
    display: block;
    line-height: 1.5;
  }
  .tags {
    display: flex;
    gap: 7px;
    align-items: center;
    margin-top: 6px;
  }
  .tags span {
    padding: 3px 7px;
    border-radius: 4px;
    background: #204432;
    color: var(--landing-accent);
    font-size: 10px;
    font-weight: 600;
  }
  .tags time {
    color: var(--landing-muted);
    font-size: 10px;
    margin-left: 2px;
  }
  .data-note {
    color: var(--landing-muted);
    font-size: 11px;
    margin-top: 18px;
  }
  .empty {
    min-height: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
    text-align: center;
    color: var(--landing-muted);
    font-size: 14px;
  }
  .empty .button {
    font-size: 12px;
  }
  .skeleton {
    height: 56px;
    border-radius: 8px;
    background: var(--landing-inset);
    opacity: 0.65;
  }
  .three-col {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 32px;
  }
  .editorial {
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 28px;
    background: var(--landing-card);
    border: 1px solid var(--landing-line);
    border-radius: ${({ theme }) => theme.cardRadius || "14px"};
  }
  .eyebrow {
    color: var(--landing-accent);
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }
  .editorial h3,
  .post h3 {
    ${fontUi};
    font-family: var(--tol-font-ui) !important;
    font-size: 16px;
    line-height: 1.55;
    font-weight: 600 !important;
  }
  .editorial p,
  .post p {
    font-size: 14px;
    color: var(--landing-muted);
  }
  .editorial .text-link {
    margin-top: auto;
  }
  .section-cta {
    display: flex;
    justify-content: center;
    margin-top: 48px;
  }
  .section-cta .button {
    width: 352px;
    min-height: 48px;
  }
  .post {
    display: flex;
    flex-direction: column;
    background: var(--landing-card);
    border: 1px solid var(--landing-line);
    border-radius: ${({ theme }) => theme.cardRadius || "14px"};
    overflow: hidden;
  }
  .post-art {
    height: 195px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(ellipse at 50% 100%, #126c3f, #122c1f);
  }
  .post-art img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .post-copy {
    padding: 26px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 1;
  }
  .post-copy .text-link {
    margin-top: auto;
  }
  .post:hover {
    border-color: #4c8063;
  }
  .faq-list {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .faq-list details {
    background: var(--landing-card);
    border-radius: ${({ theme }) => theme.controlRadius || "8px"};
    padding: 0 20px;
  }
  .faq-list summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 22px 0;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    list-style: none;
  }
  .faq-list summary::-webkit-details-marker {
    display: none;
  }
  .faq-list summary svg {
    width: 16px;
    height: 16px;
    color: var(--landing-accent);
  }
  .faq-list summary span {
    color: var(--landing-accent);
    font-size: 20px;
    transition: transform 160ms ease;
  }
  .faq-list details[open] summary span {
    transform: rotate(180deg);
  }
  .faq-list details p {
    font-size: 14px;
    padding-bottom: 22px;
  }
  .faq-section {
    padding-bottom: 76px;
    border-bottom: 0;
  }
  .footer {
    background: #020c07;
    padding: 48px 0 0;
  }
  .footer-grid {
    display: grid;
    grid-template-columns: 1.1fr 1fr 1fr;
    gap: 110px;
    padding-bottom: 48px;
  }
  .footer h3 {
    ${fontUi};
    font-family: var(--tol-font-ui) !important;
    font-size: 12px;
    font-weight: 600 !important;
    color: var(--landing-accent);
    margin-bottom: 24px;
  }
  .footer p,
  .footer a {
    font-size: 12px;
    color: var(--landing-muted);
    line-height: 1.8;
  }
  .footer p {
    max-width: 230px;
  }
  .footer a {
    display: block;
    margin-bottom: 5px;
  }
  .footer a:hover {
    color: var(--landing-accent);
  }
  .copyright {
    padding: 32px 24px;
    text-align: center;
    border-top: 1px solid #1a2820;
    font-size: 12px;
    color: var(--landing-muted);
  }
  @media (max-width: 1050px) {
    .topbar {
      padding: 0 24px;
      gap: 16px;
    }
    .nav {
      gap: 20px;
    }
    .brand {
      font-size: 13px;
    }
    .account {
      gap: 8px;
    }
    .account .button {
      font-size: 12px;
      padding: 10px 12px;
    }
    .hero {
      gap: 20px;
      grid-template-columns: 1.1fr 1fr;
    }
    h1 {
      font-size: 42px;
    }
    .numbers {
      gap: 25px;
    }
    .panel {
      padding: 20px;
    }
    .three-col {
      gap: 16px;
    }
    .editorial,
    .post-copy {
      padding: 22px;
    }
  }
  @media (max-width: 760px) {
    .wrap {
      width: calc(100% - 32px);
    }
    .topbar {
      height: 68px;
      padding: 0 16px;
      gap: 10px;
    }
    .brand span {
      display: none;
    }
    .brand svg {
      width: 32px;
      height: 32px;
    }
    .account {
      margin-left: auto;
    }
    .account .button {
      min-height: 36px;
      font-size: 11px;
      padding: 8px 10px;
    }
    .menu-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 36px;
      background: none;
      border: 1px solid var(--landing-line);
      border-radius: 8px;
      color: white;
      font-size: 21px;
    }
    .nav {
      display: none;
      position: absolute;
      top: 68px;
      left: 0;
      right: 0;
      background: #10251b;
      padding: 20px 24px;
      border-bottom: 1px solid var(--landing-line);
      gap: 24px;
      justify-content: center;
    }
    .nav.open {
      display: flex;
    }
    .hero {
      grid-template-columns: 1fr;
      padding: 52px 0 32px;
      gap: 26px;
      min-height: 0;
    }
    h1 {
      font-size: 42px;
      max-width: 380px;
    }
    .intro {
      font-size: 13px;
      max-width: 550px;
      margin-top: 20px;
    }
    .numbers {
      justify-content: space-between;
      gap: 12px;
      max-width: 410px;
      margin: 24px 0;
    }
    .numbers strong {
      font-size: 28px;
    }
    .numbers span {
      font-size: 10px;
    }
    .stores img {
      height: 38px;
    }
    .hero-art {
      width: min(400px, 100%);
      justify-self: center;
    }
    .crest-strip {
      padding: 25px 0 8px;
    }
    .crest-set {
      gap: 24px;
      padding-right: 24px;
    }
    .crest-set img {
      width: 40px;
      height: 45px;
    }
    .section {
      padding: 38px 0;
    }
    .section h2 {
      font-size: 26px;
    }
    .section-head {
      margin-bottom: 28px;
    }
    .section-head p {
      font-size: 13px;
    }
    .two-col,
    .three-col {
      grid-template-columns: 1fr;
      gap: 16px;
    }
    .panel {
      padding: 18px;
    }
    .panel-head {
      margin-bottom: 20px;
    }
    .selectors {
      gap: 10px;
      margin-bottom: 18px;
    }
    .data-row {
      padding: 11px 12px;
    }
    .data-list {
      gap: 10px;
    }
    .editorial {
      padding: 24px;
    }
    .section-cta {
      margin-top: 28px;
    }
    .section-cta .button {
      width: 100%;
    }
    .post-art {
      height: 190px;
    }
    .faq-list summary {
      font-size: 14px;
      padding: 20px 0;
    }
    .faq-list details p {
      font-size: 13px;
    }
    .footer-grid {
      grid-template-columns: 1fr 1fr;
      gap: 28px;
    }
    .footer-grid > div:first-child {
      grid-column: 1 / -1;
    }
    .footer p {
      max-width: 350px;
    }
    .footer h3 {
      margin-bottom: 12px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    scroll-behavior: auto;
  }
`;
export const LandingSelect = styled(Select)`
  ${fontUi};
  flex: 1;
  min-width: 0;
  font-size: 13px;
  .landing-select__control {
    background: var(--landing-inset);
    border: 1px solid transparent;
    border-radius: ${({ theme }) => theme.controlRadius || "8px"};
    min-height: 50px;
    box-shadow: none;
    cursor: pointer;
  }
  .landing-select__control--is-focused {
    border-color: var(--landing-accent);
  }
  .landing-select__single-value,
  .landing-select__input-container {
    color: white;
  }
  .landing-select__placeholder {
    color: var(--landing-muted);
  }
  .landing-select__indicator {
    color: white;
  }
  .landing-select__indicator-separator {
    display: none;
  }
  ${selectMenuCss("landing-select")}
  .landing-select__menu {
    background: #1c3227;
    border-color: #355040;
    color: white;
    max-width: calc(100vw - 48px);
  }
  .landing-select__option {
    color: white;
    font-size: 13px;
  }
  .landing-select__option--is-focused,
  .landing-select__option--is-selected {
    background: #2b4a38;
    color: white;
  }
  .landing-select__option--is-selected::after {
    color: #24f59a;
  }
`;
